import {OEM, OEMS_FORBIDDING_EMOJIS} from '../models/oem.enum';

export const oemPermitsEmojis = (oems: string): boolean => {
	if (!oems?.trim()) {
		return true;
	}
	const oemsArr = oems.split(',');
	if (oemsArr.length === 1) {
		const oem: OEM = oemsArr[0] as OEM;
		return !OEMS_FORBIDDING_EMOJIS.includes(oem);
	}
	return true;
};
